import { SUBSCRIPTION } from '../components/constants'

export const calcCommissionAmount = commission =>
  ((commission / 100) * SUBSCRIPTION.YEARLY_PRICE).toFixed(0)

export const getSubscriptionPlan = productId =>
  productId && productId.split('.').pop()
